import { useState, useEffect, useRef } from 'react';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import {
  ViewSwitch,
  InputDynamicWidth,
  usePagination
} from '@lk-gtcom/ecomlab-components';
import Breadcrumb from '../ArticleComponents/ArticleTypesComponent/Breadcrumb/Breadcrumb';
import { BASE_ROUTE } from '../../App';
import customHeaders, { getSpace } from '../../common/headers';
import { useResetOnBaseURL } from '../../common/useResetOnBaseURL';
import { ModalMiltilevelSidebarSettings } from '../../components/Modal/ModalMiltilevelSidebarSettings/ModalMiltilevelSidebarSettings';
import useGeneralStore from '../../store/general';
import { FilesPage } from '../FilesPage/FilesPage';
import './MainDirectory.scss';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { useResponseHandler } from '../../common/auth';

const SORT_DIRECTIONS = {
  ASC: 'ASC',
  DESC: 'DESC',
};

const SORTING_OPTIONS = [
  {
    label: 'По дате: сначала новые',
    headerField: 'Дата создания',
    direction: SORT_DIRECTIONS.DESC,
  },
  {
    label: 'По дате: сначала старые',
    headerField: 'Дата создания',
    direction: SORT_DIRECTIONS.ASC,
  },
  {
    label: 'По названию: От а до я',
    headerField: 'Название',
    direction: SORT_DIRECTIONS.ASC,
  },
  {
    label: 'По названию: От я до а',
    headerField: 'Название',
    direction: SORT_DIRECTIONS.DESC,
  },
  {
    label: 'По размеру: сначала меньше',
    headerField: 'Размер',
    direction: SORT_DIRECTIONS.ASC,
  },
  {
    label: 'По размеру: сначала больше',
    headerField: 'Размер',
    direction: SORT_DIRECTIONS.DESC,
  },
];

const MainDirectory = ({
  setPathsWebName = () => { },
  setPaths = () => { },
  directory = false,
  projectId = null,
  mainPath = '',
  fileId = null,
  pathBread,
  isShowMain,
  query
}) => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();
  const paginatorRef = useRef();
  const paginatorCallback2 = useRef();
  const [title, setTitle] = useState('')

   const [
        page,
        limit,
        total,
        setTotal,
        Paginator,
        resetPaginator,
        paginatorTransition,
    ] = usePagination(
        paginatorCallback2.current,
        [],
        paginatorRef?.current?.params
    );

  const path = useParams()['*'];

  const [selectedTopLevelValue, setSelectedTopLevelValue] = useState(0);
  const [selectedEndLevelValue, setSelectedEndLevelValue] = useState(0);
  const [currentPermission, setCurrentPermission] = useState(null)
  const [selectView, setSelectView] = useState('Tile-long');
  const sortingRef = useRef();
  const [search, setSearch] = useState('');
  const [isArticle, setIsArticle] = useState(false);
  const [fileSystemId, setFileSystemId] = useState(fileId || null)

  // Чекбоксы перемещения директории
  const [checkList, setCheckList] = useState([])
  const [isUpdateDirectory, setIsUpdateDirectory] = useState(false)

  // Крошки
  const [breadcrumbs, setBreadcrumbs] = useState([])

  // Получение крошек
  const fetchGetBreadcrumbs = (level_id, article_id) => {
    if (!level_id) return
    const file_system_id = fileSystemId ? `?file_system_id=${fileSystemId}` : ''
    let url = `https://apps2.ecomru.ru:4460/api/v1/directory/breadcrumbs/${level_id}${file_system_id}`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then(json => {
        const items = json.map(({ id, name }) => {
          return {
            label: name,
            value: id,
            web_name: null
          }
        })
        setBreadcrumbs([{
          label: 'Главная',
          value: '',
        }, ...items])
      })
      .catch(handleRequestError)
  }

  // Массовое перемещение директории 
  const fetchBulkMoveDirectory = (from_directory_id, to_directory_id) => {
    let url = `https://apps2.ecomru.ru:4460/api/v1/file/bulk-move`

    const body = JSON.stringify({
      from_directory_id,
      to_directory_id,
      file_ids: checkList
    })

    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then((json) => { })
      .catch(handleRequestError)
      .finally(() => {
        setCheckList([])
        setIsUpdateDirectory(!isUpdateDirectory)
      });
  };

  useEffect(() => {
    if (fileSystemId) {
      if (selectedTopLevelValue) {
        fetchGetBreadcrumbs(selectedTopLevelValue)
      } else {
        fetchGetBreadcrumbs(selectedEndLevelValue)
      }
    }
  }, [selectedEndLevelValue, selectedTopLevelValue, fileSystemId]);

  useResetOnBaseURL(BASE_ROUTE, () => {
    setSelectedEndLevelValue(0);
    setSelectedTopLevelValue(0);
  });

  useEffect(() => {
    setTotal(null);
    if (typeof +path?.at(-1) === 'number' && !isNaN(+path?.at(-1))) {
      setIsArticle(true);
    } else {
      setIsArticle(false);
    }
  }, [path]);

  const saveWidthColumn = () => {
    if (selectView == 'Table') {
      const colWidth = [...document.querySelectorAll('.col-th-border')];
      if (colWidth.length > 0) {
        const arrWidth = colWidth.map((el) =>
          el.style.width ? el.style.width : '247px'
        );
        sessionStorage.setItem('col-width', arrWidth);
      }
    }
  };

  useEffect(() => {
    saveWidthColumn();
  }, [selectedEndLevelValue]);


  const [selectedItemId, setSelectedItemId] = useState();

  // Метод получает файловую систему для директории файлов. Если она отсутствует, то создает её.
  const fetchGetFileDirectory = () => {
    // if (fileId) return
    let url = `https://apps2.ecomru.ru:4460/api/v1/file_directory_system${query ? `?file_system_id=${fileId}&type=${query}` : ''}`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then(json => setFileSystemId(json?.id))
      .catch(handleRequestError)
  }

  useEffect(() => {
    fetchGetFileDirectory()
  }, []);

  return (
    <>
      <div className='article-main-container__breadcrumb-and-content'>
        <div className='article-main-container__breadcrumb-and-tabs'>
          <Breadcrumb
            isShowMain={isShowMain}
            mainPath={mainPath}
            pathBread={pathBread}
            breadcrumbs={breadcrumbs}
            setBreadcrumbs={setBreadcrumbs}
            setSelectedItemId={setSelectedItemId}
            directory={directory}
            onPortalClick={(id) => {
              setSelectedTopLevelValue(id);
              setSelectedEndLevelValue(null);
            }}
          />
        </div>

        <div className="article-main-container">
          <div className='article-main-container'>
            <ModalMiltilevelSidebarSettings
              directory={directory}
              breadcrumbs={breadcrumbs}
              pathBread={pathBread}
              fetchGetBreadcrumbs={fetchGetBreadcrumbs}
              setTitle={setTitle}
              setPathsWebName={setPathsWebName}
              onPortalClick={(id) => {
                setSelectedTopLevelValue(id);
                setSelectedEndLevelValue(null);
              }}
              onLevelClick={(id) => {
                setSelectedEndLevelValue(id);
                setSelectedTopLevelValue(null);
              }}
              setPaths={setPaths}
              selectedItemId={selectedItemId}
              setSelectedItemId={setSelectedItemId}
              readonly={false}
              fileSystemId={fileSystemId}
              setCurrentPermission={setCurrentPermission}
              // массовое перемещение директории 
              checkList={checkList}
              setCheckList={setCheckList}
              onDropFile={fetchBulkMoveDirectory}
            />

            <div className="flex">
              <div className="main-content">
                <div className="toolbar-info">
                  <TitlePage
                    title={path && title}
                  />

                  <ViewSwitch
                    tile={false}
                    selectView={selectView}
                    setSelectView={(e) => setSelectView(e)}
                  />
                </div>

                <div className="article-main__header">
                  {/* <DropDownSelector
                    style={{ maxWidth: '360px' }}
                    isClearable={false}
                    options_prop={SORTING_OPTIONS.map((so) => ({
                      label: so.label,
                      value: {
                        headerField: so.headerField,
                        direction: so.direction,
                      },
                    }))}
                    state={sortingOption}
                    setState={(e) => {
                      setSortingOption(e);
                      sortingRef.current = {
                        param: e.value?.headerField,
                        direction: e.value?.direction,
                      };
                    }}
                    defaultValue={{
                      label: SORTING_OPTIONS[0].label,
                      value: {
                        param: SORTING_OPTIONS[0].headerField,
                        direction: SORTING_OPTIONS[0].direction,
                      },
                    }}
                  /> */}

                  <InputDynamicWidth
                    onChange={setSearch}
                    position="left"
                    maxWidth="100%"
                    drop={false}
                    isOpen={true}
                  />
                </div>

                <div
                  className="article-main-container__content"
                  style={{ overflow: selectView == 'Table' ? 'hidden' : 'visible' }}
                >
                  <Routes>
                    {!isArticle && (
                      <Route
                        path={`*`}
                        element={
                          <FilesPage
                            checkList={checkList}
                            setCheckList={setCheckList}
                            search={search}
                            selectView={selectView}
                            sortingRef={sortingRef}
                            projectId={projectId}
                            currentPermission={currentPermission}
                            isUpdateDirectory={isUpdateDirectory}
                          />
                        }
                      />
                    )}
                  </Routes>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { MainDirectory };
